import { useQuery, getTrendingArticles } from 'wasp/client/operations';
import { MdTrendingUp } from 'react-icons/md';
import ArticleCard from './ArticleCard';

interface TrendingArticlesProps {
  locale?: 'de' | 'en' | 'all';
}

type TrendingArticlesResult = Awaited<ReturnType<typeof getTrendingArticles>>;
type TrendingArticle = TrendingArticlesResult[number];

export default function TrendingArticles({
  locale = 'en',
}: TrendingArticlesProps) {
  const { data: trendingArticles, isLoading } = useQuery(getTrendingArticles, {
    locale,
  });

  if (isLoading || !trendingArticles?.length) return null;

  const [featured, ...rest] = trendingArticles;

  return (
    <div className="mb-12 px-4 sm:px-6">
      <div className="flex items-center justify-center gap-2 mb-6">
        <MdTrendingUp className="text-primary-400" size="2rem" />
        <h2 className="text-2xl font-bold text-neutral-900 dark:text-white">
          Trending Now
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
        <div className="h-full md:col-span-2">
          <ArticleCard article={featured} featured />
        </div>
        {rest.map((article: TrendingArticle) => (
          <div key={article.id} className="h-full">
            <ArticleCard article={article} />
          </div>
        ))}
      </div>
    </div>
  );
}
